import {t} from "@lingui/core/macro";
import {lazy} from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";

import {Layout, ToolCategories, type Tool} from "../types.ts";

import strategyIcon from "@phosphor-icons/core/regular/strategy.svg";

const CoeditingDocumentTool = lazy(
    () => import("../renderers/coediting-document-tool.tsx"),
);

export const iepAssistant: Tool = {
    urlSlug: "iep-assistant",
    configName: "teacher-tool-iep-assistant",
    title: () => t`IEP assistant`,
    description: () =>
        t`Streamline the creation of Individualized Education Plans`,
    categories: [ToolCategories.Support],
    icon: strategyIcon,
    color: color.fadedBlue24,
    layout: Layout.Coeditor,
    reportingLabelId: "iep-assistant",
    footer: () =>
        t`Note: This output is a draft and does not constitute a complete or final IEP. It requires further refinement based on your professional judgment, evaluation, and analysis. Be sure that the final IEP is tailored to the student's specific needs and complies with all applicable school policies and legal requirements.`,
    exportTargets: [
        "print",
        "download-pdf",
        "download-docx",
        "google-drive-docx",
        "microsoft-onedrive-docx",
    ],
    requestedInputs: [
        {
            description: () =>
                t`Describe context, such as grade level or class type (e.g., 5th grade reading class).`,
            inputKind: "TEXT_BOX",
            label: () => t`Learning environment`,
            required: true,
            variableName: "learningEnvironment",
        },
        {
            description: () =>
                t`Describe category (e.g., dyslexia, autism spectrum disorder, visual impairment). Note: We are FERPA-compliant, and we take privacy and confidentiality seriously. Please don’t share any personally identifiable information.`,
            inputKind: "TEXT_BOX",
            label: () => t`Disability category`,
            required: true,
            variableName: "disabilityCategory",
        },
        {
            description: () =>
                t`Describe student's current challenges, both behavioral and academic. The more details, the better; just don’t share personally identifiable information (e.g., interrupting teacher or peers, difficulty with sounding out words).`,
            inputKind: "TEXT_AREA",
            label: () => t`Current challenges`,
            required: true,
            variableName: "studentPros",
        },
        {
            description: () =>
                t`Describe student's current strengths, both behavioral and academic. The more details, the better; just don’t share personally identifiable information (e.g., a loyal friend, highly skilled at math)`,
            inputKind: "TEXT_AREA",
            label: () => t`Current strengths`,
            required: true,
            variableName: "studentCons",
        },
    ],
    component: ({providedInputs, configName, debugMode}) => {
        return (
            <CoeditingDocumentTool
                configName={configName}
                providedInputs={providedInputs}
                debugMode={debugMode}
            />
        );
    },
};
